(() => {
  const breakpoint = window.matchMedia('(min-width: 1024px)');
  const loaded = new Set();

  function loadController() {
    const mode = breakpoint.matches ? 'desktop' : 'mobile';

    if (loaded.has(mode)) return;

    const source = window.FAFNavigationAssets?.[mode];
    if (!source) return;

    const script = document.createElement('script');
    script.src = source;
    script.async = false;
    script.dataset.navigationController = mode;

    document.head.appendChild(script);
    loaded.add(mode);
  }

  loadController();

  if (breakpoint.addEventListener) {
    breakpoint.addEventListener('change', loadController);
  } else {
    breakpoint.addListener(loadController);
  }
})();